import type { MaintenanceModeConfig } from '../app-config/app-config-repository.service';

/** Upper bound so a hung CMS fetch can't stall cold-start; on timeout the gate is off (fail-open). */
export const MAINTENANCE_GATE_MAX_WAIT_MS = 4000;

/**
 * CMS maintenance kill-switch: block only when `isMaintenanceEnabled` is strictly `true`.
 * Missing object, missing flag, false, or non-boolean values never block (fail-open).
 */
export function isMaintenanceEnabled(
  maintenanceMode: MaintenanceModeConfig | null | undefined,
): boolean {
  return maintenanceMode?.isMaintenanceEnabled === true;
}

/**
 * Resolves the Maintenance CTA from `showRetry`:
 * - non-empty string → show, use that exact label ("Go to home", "Try again", …)
 * - boolean `true`   → show, label falls back to i18n (legacy CDN)
 * - omit / `false` / `""` / other → hide
 *
 * Returns `undefined` when hidden; empty string when visible with i18n fallback;
 * otherwise the CMS label.
 */
export function resolveMaintenanceRetryLabel(
  maintenanceMode: MaintenanceModeConfig | null | undefined,
): string | undefined {
  const value = maintenanceMode?.showRetry;
  if (typeof value === 'string') {
    const label = value.trim();
    return label.length > 0 ? label : undefined;
  }
  if (value === true) return '';
  return undefined;
}

/** Whether the Maintenance page may show the CTA. */
export function shouldShowMaintenanceRetry(
  maintenanceMode: MaintenanceModeConfig | null | undefined,
): boolean {
  return resolveMaintenanceRetryLabel(maintenanceMode) !== undefined;
}
